import React from 'react';

const HeaderMain = () => {
    return (
        <div className="container">
            <div className="row d-flex justify-content-center align-items-center mt-5">
            <div className="col-md-6">
                <h1 className="text-color"><b>We repair your <br/> valuable electronics</b></h1>
                <p className="text-secondary">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit iste quod explicabo perferendis ullam quo qui harum voluptate itaque exercitationem.</p>
                <button className="btn-style mb-5">All services</button>
            </div>
            <div className="col-md-6 ">
                <img src={require('../../../../images/motherboard.jpg').default} alt="" className="img-fluid mb-5"/>
            </div>
        </div>
        </div>
    );
};

export default HeaderMain;